import { AnchorHTMLAttributes } from 'react';
import Anchor from '@/components/anchor';
import useFile from '@/lib/use-file';

export default function A(props: AnchorHTMLAttributes<HTMLAnchorElement>) {
    const file = useFile();

    return <Anchor {...props} base={file.path} />;
}
